import { useState, useEffect, useCallback } from "react";
import apiFetch from "../../../../shared/services/apiClient";

export function usePrestamos() {
  const [prestamos, setPrestamos] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPrestamos = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiFetch("/api/finance/prestamos/");
      const json = await res.json();
      setPrestamos(json.results ?? json);
    } catch {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPrestamos();
  }, [loadPrestamos]);

  async function create(prestamo) {
    const res = await apiFetch("/api/finance/prestamos/", {
      method: "POST",
      body: JSON.stringify(prestamo),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.detail || "Error al crear préstamo");
    await loadPrestamos();
    return json;
  }

  async function update(id, prestamo) {
    const res = await apiFetch(`/api/finance/prestamos/${id}/`, {
      method: "PATCH",
      body: JSON.stringify(prestamo),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.detail || "Error al actualizar préstamo");
    await loadPrestamos();
    return json;
  }

  async function remove(id) {
    const res = await apiFetch(`/api/finance/prestamos/${id}/`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("No se puede eliminar (verifique que no tenga pagos registrados)");
    await loadPrestamos();
  }

  async function registrarPago(id, pago) {
    const res = await apiFetch(`/api/finance/prestamos/${id}/pagos/`, {
      method: "POST",
      body: JSON.stringify(pago),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.detail || "Error al registrar el pago");
    await loadPrestamos();
    return json;
  }

  async function eliminarPago(pagoId) {
    const res = await apiFetch(`/api/finance/pagosPrestamo/${pagoId}/`, {
      method: "DELETE",
    });
    if (!res.ok) {
      const json = await res.json().catch(() => ({}));
      throw new Error(json.detail || "Error al eliminar el pago");
    }
    await loadPrestamos();
  }

  return { prestamos, loading, create, update, remove, registrarPago, eliminarPago };
}
